module.exports = __webpack_public_path__ + "img/glc-coupe.6e752dbf.jpg";